/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IManageStaticDocumentsScope extends angular.IScope {
        model: models.StaticDocumentsModel
    }

    export class ManageStaticDocumentsController implements IController {

        constructor(
            private scope: IManageStaticDocumentsScope,
            $routeParams: angular.route.IRouteParamsService,
            manageStaticDocumentsService: services.ManageStaticDocumentsService,
            systemLevelService: services.SystemLevelService,
            deleteService: services.DeleteService,
            growl: angular.growl.IGrowlService)
        {

            this.scope.model = new models.StaticDocumentsModel(manageStaticDocumentsService, systemLevelService, deleteService, growl, $routeParams);

            this.scope.$watchCollection('model.uploadedFiles', (uploadedFiles : Wars.Domain.Model.Dtos.DocumentDto[]) => {
                if (uploadedFiles && uploadedFiles.length === 1) {
                    var document = uploadedFiles[0];
                    this.scope.model.name = document.name;

                    manageStaticDocumentsService.getStaticDocumentById(document.id)
                        .then(result => {
                            this.scope.model.staticDocument = result;
                        });
                }
            });
        }
    }
}

warsApp.registerController('ManageStaticDocumentsController', ['$scope', '$routeParams', 'manageStaticDocumentsService', 'systemLevelService', 'deleteService', 'growl']);